export default __webpack_public_path__ + "static/media/typeOffroad.faf199c8.svg";